import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { TraderItem, TradersRequest, TradersResponse } from './types'

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}
const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}

export const tradersListMounted = createEvent<TradersRequest>()

export const getTraders = fx<TradersRequest, TradersResponse>({
  method: 'GET',
  url: `/promo/anniversary/trader`,
})

export const $traders = restore<TraderItem[]>(
  getTraders.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfTraders = restore(
  getTraders.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: tradersListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }
    let newObj = {}

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (!isAllElementsOfSearchTextNotExist(searchText)) {
      newObj = { ...newObj, ...mapSearchText(searchText) }
    }

    if (Object.keys(newObj).length) {
      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    return {
      query,
    }
  },
  target: getTraders,
})
